'use strict';

/**
 * Replace a YouTube facade with its privacy-enhanced iframe after activation.
 *
 * @param {HTMLElement} button Facade button.
 * @param {Document} documentRef Document used to create the iframe.
 * @return {HTMLIFrameElement}
 */
function activateYoutubeFacade( button, documentRef ) {
	const iframe = documentRef.createElement( 'iframe' );
	const label = button.querySelector( '.youtube-facade__label' );
	const separator = button.dataset.youtubeSrc.includes( '?' ) ? '&' : '?';

	iframe.src = `${ button.dataset.youtubeSrc }${ separator }autoplay=1`;
	iframe.title = label ? label.textContent : 'YouTube-video';
	iframe.className = 'youtube-facade__iframe';
	iframe.setAttribute( 'allow', 'autoplay; encrypted-media; picture-in-picture' );
	iframe.setAttribute( 'allowfullscreen', '' );
	iframe.setAttribute( 'loading', 'eager' );
	iframe.setAttribute( 'referrerpolicy', 'strict-origin-when-cross-origin' );
	button.replaceWith( iframe );
	iframe.focus();

	return iframe;
}

/**
 * Bind click handling for all current and future YouTube facades.
 *
 * @param {Document} documentRef Document that owns the lesson content.
 */
function initializeYoutubeFacades( documentRef ) {
	documentRef.addEventListener( 'click', function ( event ) {
		const button = event.target.closest( '.youtube-facade' );

		if ( button ) {
			activateYoutubeFacade( button, documentRef );
		}
	} );
}

if ( typeof document !== 'undefined' ) {
	initializeYoutubeFacades( document );
}

if ( typeof module !== 'undefined' ) {
	module.exports = { activateYoutubeFacade, initializeYoutubeFacades };
}
